import { RouteObject } from 'react-router-dom';
import React from 'react';
import { PathUtil } from '../util/PathUtil';
import { CspPath } from '../../../CspPath';

const lazyLoadPages: () => Promise<typeof import('./RpmPages')> = () =>
  import(/* webpackPrefetch: true */ './RpmPages');

const RpmPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.RpmPage,
  })),
);

const RpmContextContentContainer = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.RpmContextContentContainer,
  })),
);

const SymptomEventDetailsNavPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.SymptomEventDetailsNavPage,
  })),
);

const RpmEventRedirectPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.RpmEventRedirectPage,
  })),
);

export const RpmRoutes: RouteObject[] = [
  {
    path: '',
    element: <RpmPage />,
    children: [
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_RPM, CspPath.PATIENT_RPM_MODULE_PAGE, true),
        element: <RpmContextContentContainer />,
      },
    ],
  },
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_RPM, CspPath.PATIENT_RPM_EVENT_DETAILS, true),
    element: <SymptomEventDetailsNavPage />,
  },
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_RPM, CspPath.PATIENT_RPM_EVENT_REDIRECT, true),
    element: <RpmEventRedirectPage />,
  },
];
